import React, { useState } from 'react';
import axios from '../../../library/axios'
import { MySwal } from '../../../library/swal'
import Button from 'react-bootstrap/Button'
import { getSlug, } from "../../../../src/config/routes/guards/slug";
import { getApiErrorMessage } from '../../../helpers/apiErrorMessage';

const CreateGroupComp = (props) => {

  const [loading, setLoading] = useState(false)
  const [disabled, setDisabled] = useState(false)
  const [group, setGroup] = useState('')
  const [fungsiRead, setfungsiRead] = useState(false)
  const [fungsiCreate, setfungsiCreate] = useState(false)
  const [fungsiEdit, setfungsiEdit] = useState(false)
  const [fungsiDelete, setfungsiDelete] = useState(false)
  const [fungsiApproval, setfungsiApproval] = useState(false)

  const handleCreateGroup = () => {
    setLoading(true)
    setDisabled(true)

    const requestBody = {
      namaGroup: group
    }
    // console.log(requestBody)
    // return false
    axios({
      url: '/groups/create',
      method: 'POST',
      data: requestBody,
      headers: { Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}` },
    })
      .then(res => {
        // console.log(res)
        // return false
        if (res.status === 200) {
          handleCreateAccessGroup(res?.data?.id)
        }
      })
      .catch(err => {
        setLoading(false)
        setDisabled(false)
        if (err !== "") {
          console.log(err?.response)
          MySwal.fire({
            icon: 'error',
            title: 'Oops, Error!',
            text: getApiErrorMessage(err)
          })
        }
      })
  }

  const handleCreateAccessGroup = (idGroup) => {
    setLoading(true)
    setDisabled(true)

    const requestBody = {
      idGroup: idGroup,
      lihat: fungsiRead === true ? 2 : 1,
      tulis: fungsiCreate === true ? 2 : 1,
      ubah: fungsiEdit === true ? 2 : 1,
      hapus: fungsiDelete === true ? 2 : 1,
      approval: fungsiApproval === true ? 2 : 1,
    }
    // console.log(requestBody)
    // return false
    axios({
      url: '/access-groups/create',
      method: 'POST',
      data: requestBody,
      headers: { Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}` },
    })
      .then(res => {
        // console.log(res)
        // return false
        if (res.status === 200) {
          MySwal.fire({
            icon: 'success',
            title: 'Success',
            text: 'Successfully created Groups!'
          })

          setLoading(false)
          setDisabled(false)

          props.close()
          props.fetch()
        }
      })
      .catch(err => {
        setLoading(false)
        setDisabled(false)
        if (err !== "") {
          console.log(err?.response?.data?.message)
          MySwal.fire({
            icon: 'error',
            title: 'Oops, Error!',
            text: getApiErrorMessage(err)
          })
        }
      })
  }

  // console.log(fungsiRead)

  return (
    <div>
      <div className="mb-3 row">
        <label htmlFor="group" className="col-sm-4 col-form-label">
          Nama Group
        </label>
        <div className="col-sm-12">
          <input
            type="text"
            className="form-control"
            id="group"
            onChange={(e) => setGroup(e.target.value)}
            value={group}
          />
        </div>
      </div>
      <div className="mb-3 row">
        <label htmlFor="group" className="col-sm-4 col-form-label">
          <span className="badge badge-info">Fungsi Group</span>
        </label>
      </div>
      {/*begin::Checkboxes*/}
      <div className="d-flex align-items-center">
        {/*begin::Checkbox*/}
        <span className="form-check-label fw-bold text-center m-lg-2">
          View
        </span>
        <label className="form-check form-check-custom form-check-solid me-5">
          <input
            className="form-check-input h-20px w-20px"
            type="checkbox"
            checked={fungsiRead}
            onClick={() => setfungsiRead(!fungsiRead)}
          />
        </label>
        {/*end::Checkbox*/}
        {/*begin::Checkbox*/}
        <span className="form-check-label fw-bold text-center m-lg-2">
          Create
        </span>
        <label className="form-check form-check-custom form-check-solid me-5">
          <input
            className="form-check-input h-20px w-20px"
            type="checkbox"
            checked={fungsiCreate}
            onClick={() => setfungsiCreate(!fungsiCreate)}
          />
        </label>
        {/*end::Checkbox*/} {/*begin::Checkbox*/}
        <span className="form-check-label fw-bold text-center m-lg-2">
          Edit
        </span>
        <label className="form-check form-check-custom form-check-solid me-5">
          <input
            className="form-check-input h-20px w-20px"
            type="checkbox"
            checked={fungsiEdit}
            onClick={() => setfungsiEdit(!fungsiEdit)}
          />
        </label>
        {/*end::Checkbox*/} {/*begin::Checkbox*/}
        <span className="form-check-label fw-bold text-center m-lg-2">
          Delete
        </span>
        <label className="form-check form-check-custom form-check-solid me-5">
          <input
            className="form-check-input h-20px w-20px"
            type="checkbox"
            checked={fungsiDelete}
            onClick={() => setfungsiDelete(!fungsiDelete)}
          />
        </label>
        {/*end::Checkbox*/}
        {/*begin::Checkbox*/}
        <span className="form-check-label fw-bold text-center m-lg-2">
          Approval
        </span>
        <label className="form-check form-check-custom form-check-solid me-5">
          <input
            className="form-check-input h-20px w-20px"
            type="checkbox"
            checked={fungsiApproval}
            onClick={() => setfungsiApproval(!fungsiApproval)}
          />
        </label>
        {/*end::Checkbox*/}
      </div>
      {/*end::Checkboxes*/}
      <div className="mt-8 row">
        <div className="col-12">
          <Button variant="danger" size="sm" onClick={() => props.close()}>
            Tutup
          </Button>
          &nbsp;
          <Button disabled={disabled} variant="success" size="sm" onClick={() => handleCreateGroup()}>{loading === true ? 'Mohon Tunggu..' : 'Simpan'}</Button>
        </div>
      </div>
    </div>
  );
};

export default CreateGroupComp;
